// Meta Pixel event helpers — fire standard events with consistent bundle data
export const PIXEL_EVENT_DATA = {
    content_name: "12,000+ eBook Mega Bundle",
    content_ids: ["drvn-dream-ebook-bundle"],
    content_type: "product",
    value: 199,
    currency: "INR",
};

export function trackPixel(event, data = {}) {
    if (typeof window === "undefined") return;
    if (typeof window.fbq !== "function") return;
    window.fbq("track", event, { ...PIXEL_EVENT_DATA, ...data });
}
